<template>
	<div class="complaint_wrapper">
		<el-dialog
        :title="$t('complaint.complaintReasonTip1')"
        :visible.sync="dialogVisible"
        width="60%"
       >
	   
		   <el-upload
			action="https://erp.shopsbu.com/service/access/upload"
			ref="upload"
			:headers="token"
			list-type="picture-card"
			:on-success="handlerUrl"
			:on-preview="handlePictureCardPreview"
			:on-remove="handleRemove">
			<i class="el-icon-plus"></i>
			</el-upload>
			<el-dialog :visible.sync="dialogVisible01" size="tiny">
			<img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
	  

        <div style="margin:20px 0" >
            <el-input type="textarea" v-model="target.sellerMsg" :placeholder="$t('complaint.complaintReasonTip2')"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('complaint.cancel')}}</el-button>
            <el-button type="primary" @click="confirm()">{{$t('complaint.determine')}}</el-button>
        </span>
        </el-dialog>

		<el-dialog
        :title="$t('complaint.complaintDetailTip')"
        :visible.sync="dialogVisible03"
        width="60%"
       >
        <div >
           <span class="img_box" v-for="(img,index) in infoData.images" :key="index">
			   <img v-image-preview style="width:100%" :src="img">
		   </span>
        </div>
        <div style="margin:20px 0" v-show="infoData.sellerMsg">
			{{$t('complaint.sellerLeaveMessage')}}：
            <el-input type="textarea" v-model="infoData.sellerMsg" :placeholder="$t('complaint.sellerLeaveMessageTip')"></el-input>
        </div>

		 <div style="margin:20px 0" v-show="infoData.storeMsg">
			 {{$t('complaint.WarehouseLeaveMessage')}}：
            <el-input type="textarea" v-model="infoData.storeMsg" :placeholder="$t('complaint.WarehouseLeaveMessageTip')"></el-input>
        </div>

		 <div style="margin:20px 0" v-show="infoData.systemMsg">
			 {{$t('complaint.PlatformLeaveMessage')}}：
            <el-input type="textarea" v-model="infoData.systemMsg" :placeholder="$t('complaint.PlatformLeaveMessageTip')"></el-input>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible03 = false">{{$t('complaint.close')}}</el-button>
            
        </span>
        </el-dialog>
    <div class="check_header">
        {{$t('complaint.PlatformLeaveMessage')}}
    </div>
	<div style="margin-bottom:20px">
		<div>{{$t('complaint.orderQuery')}}：
			<el-input style="width:250px;margin-right:5px" size="medium" v-model="orderIdSearch" :placeholder="$t('complaint.orderQueryTip')" clearable ></el-input>
			<el-button size="medium" type="primary" @click="searchOrer()">{{$t('complaint.query')}}</el-button>
		</div>
	</div>
	
	<div class="second_header">
		<el-tabs v-model="activeName2" @change="getTNVBF()" type="card" >
			<el-tab-pane :label="$t('complaint.wareHouseHaveEx')" name="first"></el-tab-pane>
			<el-tab-pane :label="$t('complaint.sellerComplaint')" name="second"></el-tab-pane>
			<!-- <el-tab-pane label="仓库已处理订单" name="third"></el-tab-pane> -->
			<el-tab-pane :label="$t('complaint.sellerComplaint')" name="four"></el-tab-pane>
		</el-tabs>
	</div>
    <div style="margin-bottom:150px">
		<div v-for="(item,index) in orderList" :key="index">
			<!-- 订单信息栏 -->
			<div class="item_desc">
				<span class="item_childre">{{$t('complaint.orderId')}}：{{item.orderId}}</span>
				<span class="item_childre">{{$t('complaint.orderStatus')}}：{{item.order ? item.order.orderStatus : item.orderStatus}}</span>
				<span class="item_childre">{{$t('complaint.orderPaid')}}：{{item.order ? item.order.escrowAmount : item.escrowAmount}}</span>
				<span class="item_childre" v-show="activeName2 == 'four'">{{$t('complaint.warehouseHaveCompensation')}}：{{item.fee}}</span>
			</div>
			<!-- 商品信息栏 -->
			<div class="item_wrapper" v-for="(children,indexTwo) in item.order ? item.order.items : item.items" :key="indexTwo">
				<div class="item_left">
					<div class="pic_box">
						<img style="width:100%" :src="children.image" />
					</div>
					<div class="left_item_box">
						<div class="itemName">{{children.itemName}}</div>
						<div class="itemName">sku：{{children.itemSku}}</div>
						<div class="itemName">{{$t('complaint.specificationName')}}：{{children.variationSku}}</div>
						<div class="itemName">{{$t('complaint.number')}}：{{children.variationQuantityPurchased}}</div>
					</div>

					<div class="left_item_box">
						<div class="itemName">{{$t('complaint.orderTime')}}：{{getTime( item.order ? item.order.createTime : item.createTime)}}</div>
						<div class="itemName">{{$t('complaint.payTime')}}：{{getTime( item.order ? item.order.payTime : item.payTime)}}</div>
						<div class="itemName">{{$t('complaint.printTime')}}：{{getTime(item.order ? item.order.printTime : item.printTime)}}</div>
						<div class="itemName">{{$t('complaint.warehouseExTime')}}：{{getTime(item.order ? item.order.packagedTime : item.packagedTime)}}</div>
						<div class="itemName">{{$t('complaint.deliveryTime')}}：{{showStoreName( item.order ? item.order.storeId : item.storeId)}}</div>
						
					</div>

					<div class="left_item_box">
						<div class="itemName">{{$t('complaint.storeName')}}：{{ item.order ? item.order.shopName : item.shopName}}</div>
						<div class="itemName">{{$t('complaint.deliveryMethod')}}：{{ item.order ? item.order.logistics : item.logistics}}</div>
						<div class="itemName">{{$t('complaint.WaybillNum')}}：{{ item.order ? item.order.trackingNo : item.trackingNo}}</div>
						<div class="itemName">{{$t('complaint.PlatformType')}}：{{ item.order ? item.order.platform : item.platform}}</div>
						<div v-if="(activeName2 == 'second' || activeName2 == 'four') && item.sellerMsg" class="itemName bvkfn">{{$t('complaint.sellerLeaveMessage')}}：{{ item.sellerMsg}}</div>
						<div v-if="(activeName2 == 'second' || activeName2 == 'four') && item.storeMsg" class="itemName bvkfn">{{$t('complaint.WarehouseLeaveMessage')}}：{{ item.storeMsg}}</div>
					</div>

				</div>
				<div>
					<div style="margin:2px 0"><el-button style="min-width:150px;margin:2px 0" v-show="activeName2 == 'first' && !item.intervene" type="primary" @click="applyOrder(item)">{{$t('complaint.complaintCompensate')}}</el-button></div>
					<div style="margin:2px 0"><el-button style="min-width:150px;margin:2px 0" v-show="activeName2 == 'second' && !item.intervene" type="primary">{{$t('complaint.waitWarehouseConfirm')}}</el-button></div>
					<div style="margin:2px 0"><el-button style="min-width:150px;margin:2px 0" v-show="activeName2 == 'second' && item.intervene" type="danger" >{{$t('complaint.waitPlatformType')}}</el-button></div>
					<div style="margin:2px 0"><el-button style="min-width:150px;margin:2px 0" v-show="activeName2 == 'four' && item.complete" type="danger" >{{$t('complaint.haveCompensation')}}{{item.fee}}{{$t('complaint.integral')}}</el-button></div>
					<div style="margin:2px 0"><el-button style="min-width:150px;margin:2px 0" v-show="activeName2 !== 'first'" type="primary" @click="viewMore(item)">{{$t('complaint.viewDetail')}}</el-button></div>
				</div>
			</div>
		</div>
	</div>

	<!-- 分页器 -->
	<div class="Pager">
		<el-pagination
		@size-change="handleSizeChange"
		@current-change="handleCurrentChange"
		:current-page="currentPage"
		:page-sizes="[15, 50, 100, 200]"
		:page-size="dataParams.offset"
		layout=" total,sizes, prev, pager, next, jumper"
		:total="orderListCount">
		</el-pagination>
		
	</div>
           
            
          
    
         
          
    
	</div>
</template>

<script>
import orderApi from '../../../api/moudles/order'
import newOrders from '@/api/moudles/newOrders'  
import { mapState, mapMutations } from 'vuex'
import api from '../../../api/api'
import utils from '../../../utils/utils'

	export default {
		data() {
			return {
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')) ,
				userShopslazada:JSON.parse(localStorage.getItem('lazadashopId')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				lazadashopId: JSON.parse(localStorage.getItem('lazadashopId')),
                NumType:4,
				shophasAuthorization:JSON.parse(localStorage.getItem('shophasAuthorization')),
                shopOptions:[],
                productUrl:'',
                activeName2:'first',
				dataParams:{},
				allStoreIds:[],
				allShopIds:JSON.parse(localStorage.getItem('userInfo')).shopIds,
				orderList:[],
				orderListCount:0,
				currentPage:1,
				dialogVisible:false,
				dialogVisible01:false,
				target:{
					
				},
				dialogImageUrl:'',
				dialogVisible: false,
				token:{
				token:JSON.parse(localStorage.getItem('userInfo')).token
				},
				imageUrl:[],
				infoData:{
					images:[],
					sellerMsg:'',
				},
				dialogVisible03:false,
				orderIdSearch:null
			
                
				
			}
		},
	
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId,
			}),

		},
		watch:{
			activeName2(){
				this.orderIdSearch=null
				this.dataParams.type=0
				this.dataParams.page=0
				this.dataParams.orderId=null
				this.dataParams.sellerId=null
				if(this.activeName2 == 'second'){
					this.dataParams.complete=false
					this.getSellerOrder()
				}

				if(this.activeName2 == 'first'){
					this.getSellerProsecutionOrder()
				}

				if(this.activeName2 == 'four'){
					this.dataParams.complete=true
					this.getSellerOrder()
				}
				
			},
			dialogVisible(){
				if(!this.dialogVisible){
					this.$refs.upload.clearFiles()
					this.imageUrl=[]
				}
			},
			orderIdSearch(){
				if(!this.orderIdSearch){
					this.dataParams.orderId=null
					this.dataParams.page=0
					if(this.activeName2 == 'first'){
						this.getSellerProsecutionOrder()
					}

					if(this.activeName2 == 'second' || this.activeName2 == 'four'){
						this.getSellerOrder()

					}
				}
			}
		},
        filters:{
            
        },
		created(){
			this.init()
			this.getSellerProsecutionOrder()
		},
		methods: {

            ...mapMutations("common", [
                "SET_REGISTOR_FALSE",
                'SWITCH_LANG',
            ]),

			searchOrer(){
				if(!this.orderIdSearch){
					return
				}
				this.dataParams.orderId=this.orderIdSearch
				this.dataParams.page=0
				if(this.activeName2 == 'first'){
					this.getSellerProsecutionOrder()
				}

				if(this.activeName2 == 'second' || this.activeName2 == 'four'){
					this.getSellerOrder()

				}

				
				
			},

			viewMore(item){
				console.log(item)
				if(item.images){
					this.infoData.images=item.images.split(',').filter(p => {
						if(p){
							return p
						}
					})

				}else{
					this.infoData.images=[]
				}

				console.log(this.infoData.images)

				this.infoData.sellerMsg=item.sellerMsg
				this.infoData.storeMsg=item.storeMsg
				this.infoData.systemMsg=item.systemMsg
				this.dialogVisible03=true
			},

			confirm(){
				this.target.images=this.imageUrl.join(',')
				console.log(this.target)
				console.log(this.imageUrl)

				newOrders
				.apply(this.target)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				this.$message.success(this.$t('other.a570'))
				this.dialogVisible=false
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
	

			applyOrder(item){

				this.target={
					fee:null,
					images:this,
					order:item,
					sellerMsg:null,
					storeId:item.storeId,
					orderId:item.orderId,
					storeMsg:null,
					systemMsg:null,
					userId:this.userId,
					complete:0

				}

				
				this.dialogVisible=true
				// this.$confirm('确认要发起投诉索赔吗？', this.$t("other.a142"), {
				// confirmButtonText: this.$t('other.a145'),
				// cancelButtonText: this.$t('other.a146'),
				// type: 'warning'
				// }).then(() => {

				// 	console.log(item)
				// 	newOrders
				// 	.apply(item)
				// 	.then(res => {
				// 	if(res.code === 200 ){
				// 	console.log('desc',res.data)
				// 	this.$message.success(this.$t('other.a570'))
				// 	}else{
				// 	this.$message.warning(res.msg)
				// 	}
				// 	})
				// })
			},

			//获取卖家申诉的订单
			getSellerOrder(){
				this.orderList=[]
				newOrders
				.getSellerComplainOrder(this.dataParams)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				this.orderList=res.data.complains
				this.orderListCount=res.data.count
				console.log('order',this.orderList)
				}else{
				this.$message.warning(res.msg)
				}
				})
			},

			//获取卖家可追诉订单
			getSellerProsecutionOrder(){
				
				orderApi
				.getDistrustOrders(this.dataParams)
				.then(res => {
				if(res.code === 200 ){
				console.log('卖家可追诉订单',res.data)
				this.orderList=res.data.orders
				this.orderListCount=res.data.count
				}else{
				this.message.warning(res.msg)
				}
				})
			},

			// getSellerOrder(){
			// 	newOrders
			// 	.getSellerComplainOrder(this.dataParams)
			// 	.then(res => {
			// 	if(res.code === 200 ){
			// 	console.log('desc',res.data)
			// 	}else{
			// 	this.message.warning(res.msg)
			// 	}
			// 	})
			// },

			init(){
				this.allStoreIds=utils.getAllstorIdsByisUsedForTrue()
				this.dataParams.end=null
				this.dataParams.start=null
				this.dataParams.offset=50
				this.dataParams.orderType=10
				this.dataParams.page=0
				this.dataParams.platform=null
				this.dataParams.shopIds=this.allShopIds
				this.dataParams.sortType=0
				this.dataParams.storeIds=this.allStoreIds
				this.dataParams.userId=this.userId
				

				console.log(this.dataParams)

			},

			handleRemove(file, fileList) {
				console.log(file, fileList);
				if(fileList.length){
					this.imageUrl=fileList.map(p => {
						return p.response.data
					})
				}else{
					this.imageUrl=[]
				}
			},
			handlePictureCardPreview(file) {
				console.log(file)
				this.dialogImageUrl = file.url;
				console.log(this.dialogImageUrl)
				this.dialogVisible01 = true;
			},

			handlerUrl(file){
				console.log(file)
				this.imageUrl.push(file.data)
			},
			
			getTime(time){
				return utils.renderTime(time)
			},
			showStoreName(id){
				return utils.showStoreName(id)
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.dataParams.offset=parseInt(`${val}`)
				this.handleCurrentChange()
			},
			//显示当前第几页
			handleCurrentChange(val) {
				this.currentPage=parseInt(`${val}`)
				this.dataParams.page=parseInt(`${val}`) ? (parseInt(`${val}`) -1) * this.dataParams.offset : 0
				this.getSellerProsecutionOrder()	
				
			},

          


            



   
		
	


		}
	}
</script>

<style lang="scss" scoped>
.complaint_wrapper{

    // flex:1;
    // margin: 50px 0 0 223px;
    
	box-sizing: border-box;
	padding: 0 15px;

    .check_header{
        font-size: 18px;
        margin:10px 0 20px 0
        
    }

	.bvkfn{
		color: red;
	}



	.img_box{
		display: inline-block;
		width: 80px;
		height: 80px;
		overflow: hidden;
	}


	.item_desc{
		box-sizing: border-box;
		padding: 5px 10px;
		border: 1px solid #eee;
		font-size: 18px;


		.item_childre{
				margin-right: 20px;
			}
	}


	.item_wrapper{
		display: flex;
		box-sizing: border-box;
		padding: 5px 10px;
		justify-content: space-between;
		border-top: 1px solid #eee;
		
		.item_left{
			display: flex;
			

			

			.left_item_box{
				box-sizing: border-box;
				padding: 10px;
			}

			.itemName{
				width: 250px;
				display: -webkit-box;
				overflow: hidden;
				text-overflow: ellipsis;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;


			}
		}
		
		.pic_box{
			width: 100px;
			height: 100px;
			overflow: hidden;
		}
	}

	




    .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

}

	
	

</style>
